import { render } from "./LegacyWebhookTrigger.vue?vue&type=template&id=2fc032fc"
import script from "./LegacyWebhookTrigger.vue?vue&type=script&lang=js"
export * from "./LegacyWebhookTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script